import Vue from 'vue'

export default {
	state: {
		intermediate: [],
		adjustedSales: []
	},
	mutations: {
		loadIntermediate (state, payload) {
			state.intermediate = payload
		},
		addIntermediate (state, payload) { 
			const index = state.intermediate.length 
			Vue.set(state.intermediate, index, payload)  
		},
		loadAdjustedSales (state, payload) {
			state.adjustedSales = payload
		},
		addAdjustedSales (state, payload) { 
			const index = state.adjustedSales.length 
			Vue.set(state.adjustedSales, index, payload)  
		},		
	},
	actions: {
		async fetchIntermediate ({commit, getters}, payload = null) {
			commit('clearError')
			commit('setLoading', true)

			let gameId = 'game'
			let round = 'round'

			if (payload) {
				gameId+= payload.gameId
				round+= payload.round
			}
			else {
				gameId += getters.gameId
				round += getters.currentRound
			}

			try {
				const intermediate = await Vue.$db.collection(gameId).doc(round)
				.collection('intermediate')
				.orderBy("month", "asc")
				.get()

				if (intermediate.empty) {//no intermediate
					//console.log('no intermediate')	
				}
				else {
					const res = []
					intermediate.forEach(doc => {
						const month = doc.data()
						month.id = doc.id
						res.push(month)
					})
					commit('loadIntermediate', res)
				}
				
				commit('setLoading', false)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		async addIntermediate ({commit}, payload) {
			commit('clearError')
			commit('setLoading', true)
			const id = `segmentsMaxSize-month${payload.monthDemand.month}`

			try {
				await Vue.$db.collection('game' + payload.gameId).doc('round'+ payload.round)
				.collection('intermediate')
				.doc(id)
				.set(payload.monthDemand)

				payload.monthDemand.id = id
				commit('setLoading', false)
				commit('addIntermediate', payload)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		async fetchAdjustedSales ({commit, getters}, payload = null) {
			commit('clearError')
			commit('setLoading', true)

			let gameId = 'game'
			let round = 'round'

			if (payload) {
				gameId+= payload.gameId
				round+= payload.round
			}
			else {
				gameId += getters.gameId
				round += getters.currentRound - 1
			}

			try {
				const sales = await Vue.$db.collection(gameId).doc(round)
				.collection('adjustedSales')
				.orderBy("month", "asc")
				.get()

				if (sales.empty) {//no models
					console.log('no adjusted sales')	
				}
				else {
					const res = []
					sales.forEach(doc => {
						const month = doc.data()
						month.id = doc.id
						res.push(month)
					})
					commit('loadAdjustedSales', res)
				}
				
				commit('setLoading', false)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		async addAdjustedSales ({commit}, payload) {
			commit('clearError')
			commit('setLoading', true)
			const id = `adjustedSales-${payload.month.month}`
			
			try {
				await Vue.$db.collection('game' + payload.gameId).doc('round'+ payload.round)
				.collection('adjustedSales')
				.doc(id)
				.set(payload.month)

				payload.month.id = id
				commit('setLoading', false)
				commit('addAdjustedSales', payload.month)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
	},
	getters: {
		intermediate (state) {
			//console.log(state.intermediate)
			return state.intermediate
		},
		adjustedSales (state) {//sorted by month
			let resArr = []
			state.adjustedSales.map(item => {
				resArr[item.month - 1] = item.sales
			})
			return resArr
		}
	}
}